import './App.css';
import { useState, useEffect } from 'react';
import { Amplify } from 'aws-amplify';
import { withAuthenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import config from './aws-exports.js'; 
import { get } from 'aws-amplify/api'; 
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider, createTheme, responsiveFontSizes } from '@mui/material/styles';
import AddUrgentTaskingPage from './social-media-tasking/pages/addUrgentTaskingPage.js';
import AddFaceprintPage from './faceprint-mgt/pages/addFaceprintPage.js';
import AddGroupTagPage from './group-tagging/pages/addGroupTagPage.js';
import AddKeywordPage from './keyword-mgt/pages/addKeywordPage.js';
import AddTaskingPage from './social-media-tasking/pages/addTaskingPage.js';
import DashboardPage from './dashboard/pages/dashboardPage.js';
import DownloadPage from './file-transfer-host/pages/downloadPage.js';
import EmulatorPage from './emulators/emulatorPage.js';
import GroupPage from './emulators/groupPage.js';
// import HomePage from './home/homePage.js';
import ModifyFaceprintPage from './faceprint-mgt/pages/modifyFaceprintPage.js';
import ModifyGroupTagPage from './group-tagging/pages/modifyGroupTagPage.js';
import ModifyKeywordPage from './keyword-mgt/pages/modifyKeywordPage.js';
import ModifyTaskingPage from './social-media-tasking/pages/modifyTaskingPage.js';
import ManageTaskingPage from './social-media-tasking/pages/manageTaskingPage.js';
import NavigationBar from './shared/navigationBar.js';
// import ViewAdhocTaskingPage from './social-media-tasking/pages/viewAdhocTaskingPage.js';
import ViewAllUrgentTaskingPage from './social-media-tasking/pages/viewAllUrgentTaskingPage.js';
import ViewAllFaceprintPage from './faceprint-mgt/pages/viewAllFaceprintPage.js';
import ViewAllGroupTagPage from './group-tagging/pages/viewAllGroupTagPage.js';
import ViewAllKeywordPage from './keyword-mgt/pages/viewAllKeywordPage.js';
import ViewAllTaskingPage from './social-media-tasking/pages/viewAllTaskingPage.js';
import ViewTaskingPage from './social-media-tasking/pages/viewTaskingPage.js';
import Button from '@mui/material/Button'; 
import TextField from '@mui/material/TextField';
import Rating from '@mui/material/Rating'; 
import Alert from '@mui/material/Alert'; 
import Collapse from '@mui/material/Collapse';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import styled from 'styled-components'; 
import { LicenseInfo } from '@mui/x-license';
import fetch from "node-fetch"; 
import logo from './tab-logo.svg'; 
import * as endpoints from './endpoints.js';
import { v4 as uuid } from "uuid"; 
import { put } from 'aws-amplify/api';
import { getUrl } from 'aws-amplify/storage'; 
// import {
//   SecretsManagerClient,
//   GetSecretValueCommand,
// } from "@aws-sdk/client-secrets-manager";

// const secret_name = "hunnycloud/test";

// const client = new SecretsManagerClient({
//   region: "ap-southeast-1",
// });

// let response;

// try {
//   response = await client.send(
//     new GetSecretValueCommand({
//       SecretId: secret_name,
//       VersionStage: "AWSCURRENT", // VersionStage defaults to AWSCURRENT if unspecified
//     })
//   );
// } catch (error) {
//   // For a list of exceptions thrown, see
//   // https://docs.aws.amazon.com/secretsmanager/latest/apireference/API_GetSecretValue.html
//   throw error;
// }

// const secret = response.SecretString; 

LicenseInfo.setLicenseKey('0c26f9199b0974af9c69c4c6a9cd04ccTz05ODcyMixFPTE3NTg3Nzk5NzMwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLFBWPVEzLTIwMjQsS1Y9Mg==');
let theme = responsiveFontSizes(createTheme({
  typography: {
    allVariants: {
      fontFamily: 'Inter Tight',
      textTransform: 'none', 
    },
  }, 
}));
Amplify.configure(config);

const Box = styled.div`
  width: 100%;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

function App({user, signOut}) {
  const [open, setOpen] = useState(false);
  const [feedback, setFeedback] = useState({
    rating: 0,
    type: "",
    message: ""
  }) 
  const [feedbackAlert, setFeedbackAlert] = useState({
    open: false,
    status: null,
    message: ""
  })
 
  useEffect(() => {   
    // console.log("secret", secret)
    const getTeam = async () => {
      try {
        const getOperation = get({ 
          apiName: 'gccusermapapi',
          path: '/gccusermap' 
        });
        const { body } = await getOperation.response;
        const json = await body.json(); 
        const username = user.username; 
        let team = ""; // Only to check if user-to-team mapping exists for current user
        json.forEach((obj) => { 
          if (obj.username === username) { 
            team = obj.team;   
            user.team = team; 
            return;
          }});
        if (team.length === 0) { 
          console.log("User-to-team mapping for this user does not exist.");
        } 
        // console.log('GET call succeeded: ', json); 
      } catch (error) {
        console.log('GET call failed: ', error);
      }
    } 
    getTeam();    
  }, [user]);
  
  const handleTelemetry = ({application, application_server, comms_guid, es_record_id, event, sub_event}) => { 
    const body = {
      application: application,
      application_server: application_server,
      comms_guid: comms_guid,
      es_record_id: es_record_id,
      event: event,
      sub_event: sub_event,
      log_datetime: Date.parse(new Date()).toString(),
      log_datetime_str: new Date().toLocaleString('sv-SE', { timeZoneName: 'short' }).replace(' ', 'T').replace('UTC', '+08:00'),
      log_source: "hunnycloud2",
      runtime_environment: "dev",
      team: user.team,
      user: user.username
    }  
    const log = async () => {
      await fetch(endpoints.LOGGING, { 
        headers: {
            authorizationToken: endpoints.AUTHORIZATION_TOKEN
        },
        method: "POST",
        body: JSON.stringify(body) 
      }).catch((err) => {
          console.log("Log Error:", err); 
      });  
    }     
    log();
  } 
  
  const handleClickOpenFeedback = () => {
    setOpen(true);
  };

  const handleCloseFeedback = () => {
    setOpen(false);
    setFeedbackAlert(prev => ({...prev, open: false})); 
    setFeedback({ rating: 0, type: "", message: "" });
  };
  
  const submitFeedback = async () => {
    try {
      const putOperation = put({
        apiName: 'gccfeedbackapi',
        path: '/gccfeedback',
        options: {
          body: {
            PK: uuid().slice(0, 8), 
            username: user.username,
            team: user.team,
            rating: feedback.rating,
            type: feedback.type,
            message: feedback.message,
            date_submitted: Date.parse(new Date()), 
          }
        }
      })
      await putOperation.response; 
      setFeedbackAlert({ open: true, status: true, message: "Successfully submitted. Thank you for your feedback!"});
      setFeedback({ rating: 0, type: "", message: "" }); // Reset to default
    } catch (err) {
      setFeedbackAlert({ open: true, status: false, message: "Failed to submit. Please try again later."});
      console.log('PUT call failed: ', err);
    }    
  }
   
  const handleSubmitFeedback = () => {
    if (feedback.rating !== 0 && feedback.type !== "") {
      submitFeedback();
      // setFeedbackAlert({ open: true, status: true, message: "Successfully submitted. Thank you for your feedback!"});
    } else {
      setFeedbackAlert({ open: true, status: false, message: "Failed to submit. Please fill up all mandatory fields! "});
    }
  }
  
  return (
      <ThemeProvider theme={theme}> 
        <Box className="App">  
          <BrowserRouter>  
              <NavigationBar signOut={signOut} callback={handleClickOpenFeedback} user={user}/>
              <Routes>
                <Route path="/" element={<Navigate replace to="/dashboard" />} />
                <Route path="/home" element={<Navigate replace to="/dashboard" />} />
                <Route exact path="/keyword-mgt/add" element={<AddKeywordPage user={user} telemetry={handleTelemetry}/>} />
                <Route exact path="/keyword-mgt/view" element={<ViewAllKeywordPage user={user} telemetry={handleTelemetry}/>} /> 
                <Route exact path="/keyword-mgt/view/:pk" element={<ModifyKeywordPage user={user} telemetry={handleTelemetry}/>} /> 
                <Route exact path="/issue-tagging/add" element={<AddGroupTagPage user={user} telemetry={handleTelemetry}/>} />
                <Route exact path="/issue-tagging/view" element={<ViewAllGroupTagPage user={user}/>} /> 
                <Route exact path="/issue-tagging/view/:pk" element={<ModifyGroupTagPage user={user}/>} />
                <Route exact path="/emulators/emulator-info" element={<EmulatorPage user={user}/>} />
                <Route exact path="/emulators/group-info" element={<GroupPage user={user}/>} />
                <Route exact path="/faceprint-mgt/add" element={<AddFaceprintPage user={user}/>} /> 
                <Route exact path="/faceprint-mgt/view" element={<ViewAllFaceprintPage user={user}/>} />
                <Route exact path="/faceprint-mgt/view/:pk" element={<ModifyFaceprintPage user={user}/>} />
                <Route exact path="/social-media-tasking/add" element={<AddTaskingPage user={user}/>} /> 
                <Route exact path="/social-media-tasking/manage-team" element={<ManageTaskingPage user={user}/>} />
                <Route exact path="/social-media-tasking/manage-team/:pk" element={<ModifyTaskingPage user={user}/>} />
                <Route exact path="/social-media-tasking/view" element={<ViewAllTaskingPage user={user}/>} /> 
                <Route exact path="/social-media-tasking/view/:pk" element={<ViewTaskingPage user={user}/>} /> 
                <Route exact path="/social-media-urgent-tasking/add" element={<AddUrgentTaskingPage user={user}/>} /> 
                <Route exact path="/social-media-urgent-tasking/view" element={<ViewAllUrgentTaskingPage user={user}/>} />  
                <Route path="/media-download" element={<DownloadPage/>} /> 
                <Route exact path="/dashboard" element={<DashboardPage user={user} telemetry={handleTelemetry}/>} />
              </Routes> 
          </BrowserRouter>
          <Dialog
            open={open}
            onClose={handleCloseFeedback}   
            sx={{
              "& .MuiDialog-container": {
                "& .MuiPaper-root": {
                  width: "100%",
                  maxWidth: "630px",  
                },
              },
            }}        
          > 
          <Box className="feedback-logo">
            <img src={logo} width="70" />
          </Box>
          <Box className="feedback-header">
            <DialogTitle><h3>Your feedback is important to us.</h3></DialogTitle>
          </Box>
          <DialogContent> 
            <DialogContentText sx={{ fontSize: "18px" }}>
              How satisfied are you with the features of Hunnycloud? <span style={{color: "red"}}>*</span>
            </DialogContentText>  
            <Rating
              name="simple-controlled" 
              value={feedback.rating}
              size="large"
              onChange={(event, newValue) => { 
                if (newValue === null) { 
                  setFeedback(prev => ({...prev, rating: 0}));  
                } else { 
                  setFeedback(prev => ({...prev, rating: newValue}));
                }
              }} 
              sx={{ paddingTop: "5px" }}
            />      
            <DialogContentText sx={{ paddingTop: "20px", fontSize: "18px" }}>
              Feedback Type <span style={{color: "red"}}>*</span>
            </DialogContentText>    
            <Box>
              <FormControl margin="dense" fullWidth> 
                <Select
                  autoWidth
                  displayEmpty
                  labelId="demo-simple-select-label"
                  id="demo-simple-select" 
                  value={feedback.type} 
                  onChange={(event) => setFeedback(prev => ({...prev, type: event.target.value}))}
                >
                  <MenuItem disabled value="">
                    <em>Select Type</em>
                  </MenuItem>         
                  <MenuItem value={"General"}>General</MenuItem>
                  <MenuItem value={"Bug"}>Bug</MenuItem>
                  <MenuItem value={"Feature Enhancement"}>Feature Enhancement</MenuItem> 
                  <MenuItem value={"Others"}>Others</MenuItem> 
                </Select>
              </FormControl>
            </Box>
            <DialogContentText sx={{ paddingTop: "25px", paddingBottom: "10px", fontSize: "18px" }}>
              Please elaborate on your feedback. 
            </DialogContentText>
            <TextField  
              fullWidth
              variant="outlined"
              multiline
              maxRows={5} 
              inputProps={{
                onBlur: (event) => setFeedback(prev => ({...prev, message: event.target.value}))
              }}        
            />
          </DialogContent> 
          <DialogActions sx={{ "&.MuiDialogActions-root": { paddingBottom: "2rem !important"}}}>
                <Box className="feedback-buttons">  
                  <Button variant="outlined" className="dialog-button" onClick={handleCloseFeedback}>
                      <div className="dialog-button-text">
                          Cancel
                      </div>
                  </Button>
                  <Button variant="outlined" className="dialog-button" onClick={handleSubmitFeedback}>
                      <div className="dialog-button-text">
                          Submit
                      </div>
                  </Button>
                </Box>
          </DialogActions> 
          <Collapse in={feedbackAlert.open}>
          <Box className="feedback-alert">
            <Alert  
              style={{ width: "70%" }} 
              severity={feedbackAlert.status ? "success" : "error"}
            >
              {feedbackAlert.message}
            </Alert>          
          </Box> 
          </Collapse>
        </Dialog>  
        </Box>
      </ThemeProvider>
  );
}

export default withAuthenticator(App, { hideSignUp: true }); 

                // <Route index path="/home" element={<HomePage user={user}/>} /> 
                // <Route exact path="/emulators" element={<EmulatorPage user={user}/>} />